@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(335_515_460)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20253, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20057, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20693, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18269, 67),
      ))
    }

@delegate:ResourceContentHash(721_891_758)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", "TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20337, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20133, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20777, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18337, 81),
      ))
    }

@delegate:ResourceContentHash(1_782_810_894)
public val Res.string.UPDATE_AGE_INFO: StringResource by lazy {
      StringResource("string:UPDATE_AGE_INFO", "UPDATE_AGE_INFO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20435, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20223, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20871, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18419, 95),
      ))
    }

@delegate:ResourceContentHash(-1_366_325_385)
public val Res.string.UPDATE_AGE_LOW_AGE_ERROR: StringResource by lazy {
      StringResource("string:UPDATE_AGE_LOW_AGE_ERROR", "UPDATE_AGE_LOW_AGE_ERROR", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20555, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20327, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20987, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18515, 68),
      ))
    }

@delegate:ResourceContentHash(-556_317_788)
public val Res.string.UPDATE_AGE_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_AGE_SCREEN_TITLE", "UPDATE_AGE_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20628, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20400, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21068, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18584, 43),
      ))
    }

@delegate:ResourceContentHash(-907_725_017)
public val Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", "UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20676, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20444, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21116, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18628, 68),
      ))
    }

@delegate:ResourceContentHash(-813_113_550)
public val Res.string.UPDATE_FOOD_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_SCREEN_TITLE", "UPDATE_FOOD_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20757, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20521, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21205, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18697, 44),
      ))
    }

@delegate:ResourceContentHash(-1_500_631_541)
public val Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20818, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20574, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21262, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18742, 85),
      ))
    }

@delegate:ResourceContentHash(1_722_639_085)
public val Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20916, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20664, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21364, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18828, 84),
      ))
    }

@delegate:ResourceContentHash(713_811_975)
public val Res.string.UPDATE_HEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_SCREEN_TITLE", "UPDATE_HEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21009, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20753, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21465, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18913, 50),
      ))
    }

@delegate:ResourceContentHash(-2_023_604_917)
public val Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", "UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21064, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20800, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21516, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18964, 70),
      ))
    }

@delegate:ResourceContentHash(-195_462_778)
public val Res.string.UPDATE_NAME_INFO: StringResource by lazy {
      StringResource("string:UPDATE_NAME_INFO", "UPDATE_NAME_INFO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21135, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20863, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21587, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19035, 76),
      ))
    }

@delegate:ResourceContentHash(-1_398_845_473)
public val Res.string.UPDATE_NAME_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_NAME_SCREEN_TITLE", "UPDATE_NAME_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21220, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20944, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21684, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19112, 44),
      ))
    }

@delegate:ResourceContentHash(-400_915_889)
public val Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_TARGET_WEIGHT_SCREEN_TITLE", "UPDATE_TARGET_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21265, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20989, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21729, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19157, 65),
      ))
    }

@delegate:ResourceContentHash(-341_299_630)
public val Res.string.UPDATE_WEIGHT_INFO_LABEL: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_INFO_LABEL", "UPDATE_WEIGHT_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21331, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21055, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21795, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19223, 120),
      ))
    }

@delegate:ResourceContentHash(417_801_622)
public val Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_LOG_SCREEN_TITLE", "UPDATE_WEIGHT_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21512, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21196, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21948, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19344, 62),
      ))
    }

@delegate:ResourceContentHash(417_801_622)
public val Res.string.UPDATE_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_SCREEN_TITLE", "UPDATE_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21587, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21259, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22023, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19407, 58),
      ))
    }

@delegate:ResourceContentHash(-1_091_732_948)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", "USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21658, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21318, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22094, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19466, 87),
      ))
    }

@delegate:ResourceContentHash(1_508_685_540)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", "USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21774, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21410, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22194, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19554, 63),
      ))
    }

@delegate:ResourceContentHash(432_633_088)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_TITLE", "USER_AVATAR_DELETE_CONFIRMATION_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21842, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21478, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22262, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19618, 65),
      ))
    }

@delegate:ResourceContentHash(818_727_618)
public val Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", "USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21908, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21544, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22332, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19684, 62),
      ))
    }

@delegate:ResourceContentHash(-774_193_583)
public val Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", "USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21979, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21611, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22403, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19747, 66),
      ))
    }

@delegate:ResourceContentHash(-284_568_502)
public val Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", "USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22050, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21682, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22474, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19814, 75),
      ))
    }

@delegate:ResourceContentHash(-48_897_848)
public val Res.string.USER_AVATAR_IMAGE_PICKER_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_TITLE", "USER_AVATAR_IMAGE_PICKER_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22130, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21758, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22554, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19890, 62),
      ))
    }

@delegate:ResourceContentHash(279_095_314)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", "USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22205, 243),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21825, 227),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22629, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19953, 195),
      ))
    }

@delegate:ResourceContentHash(676_730_041)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", "USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22449, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22053, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22865, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20149, 67),
      ))
    }

@delegate:ResourceContentHash(-1_709_531_031)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_TITLE", "USER_AVATAR_PERMISSION_REQUIRED_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22525, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22129, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22937, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20217, 73),
      ))
    }

@delegate:ResourceContentHash(-454_252_886)
public val Res.string.WEIGHT_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:WEIGHT_HISTORY_SCREEN_TITLE", "WEIGHT_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22603, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22199, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23007, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20291, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE)
  map.put("UPDATE_AGE_INFO", Res.string.UPDATE_AGE_INFO)
  map.put("UPDATE_AGE_LOW_AGE_ERROR", Res.string.UPDATE_AGE_LOW_AGE_ERROR)
  map.put("UPDATE_AGE_SCREEN_TITLE", Res.string.UPDATE_AGE_SCREEN_TITLE)
  map.put("UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE)
  map.put("UPDATE_FOOD_SCREEN_TITLE", Res.string.UPDATE_FOOD_SCREEN_TITLE)
  map.put("UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_SCREEN_TITLE", Res.string.UPDATE_HEIGHT_SCREEN_TITLE)
  map.put("UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_NAME_INFO", Res.string.UPDATE_NAME_INFO)
  map.put("UPDATE_NAME_SCREEN_TITLE", Res.string.UPDATE_NAME_SCREEN_TITLE)
  map.put("UPDATE_TARGET_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_INFO_LABEL", Res.string.UPDATE_WEIGHT_INFO_LABEL)
  map.put("UPDATE_WEIGHT_LOG_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_SCREEN_TITLE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_TITLE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE)
  map.put("USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_TITLE", Res.string.USER_AVATAR_IMAGE_PICKER_TITLE)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_TITLE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE)
  map.put("WEIGHT_HISTORY_SCREEN_TITLE", Res.string.WEIGHT_HISTORY_SCREEN_TITLE)
}
